import React from 'react';

import { useIsDesktop } from '../hooks/useIsDesktop';

export function HotelListLoader() {
    const isDesktop = useIsDesktop();

    return (
        <>
            <div className="bg-[#D0D0D0] h-[84px] mb-[25px] animation-pulse" />
            <div className="bg-[#D0D0D0] h-[198px] mb-[24px] animate-pulse" />
            <div className="flex flex-col gap-[24px]">
                <div className="bg-[#D0D0D0] h-[198px] animate-pulse" />
                <div className="bg-[#D0D0D0] h-[198px] animate-pulse" />
                <div className="bg-[#D0D0D0] h-[198px] animate-pulse" />
                {isDesktop &&
                    <div className="bg-[#D0D0D0] h-[198px] animate-pulse" />
                }
            </div>
        </>
    );
}
